import React, {
  createContext, useCallback, useContext, useEffect, useRef,
} from 'react';
import PropTypes from 'prop-types';

const FacetPolicyTranslationContext = createContext(null);

function interpolate(message, values) {
  return Object.keys(values || {}).reduce(
    (result, key) => result.replace(new RegExp(`\\{${key}\\}`, 'g'), String(values[key])),
    message,
  );
}

export function FacetPolicyTranslationProvider({ translate, children }) {
  const translateRef = useRef(translate);
  useEffect(() => { translateRef.current = translate; }, [translate]);
  const stableTranslate = useCallback((id, values) => (
    translateRef.current ? translateRef.current(id, values) : null
  ), []);
  return (
    <FacetPolicyTranslationContext.Provider value={stableTranslate}>
      {children}
    </FacetPolicyTranslationContext.Provider>
  );
}

export function useFacetPolicyTranslation() {
  const translate = useContext(FacetPolicyTranslationContext);
  return useCallback((id, fallback, values = {}) => {
    if (typeof translate !== 'function') return interpolate(fallback, values);
    const translated = translate(id, values);
    return translated && translated !== id ? translated : interpolate(fallback, values);
  }, [translate]);
}

FacetPolicyTranslationProvider.propTypes = {
  translate: PropTypes.func,
  children: PropTypes.node.isRequired,
};

FacetPolicyTranslationProvider.defaultProps = { translate: null };
